import React from "react";
import BubbleMarkdown from "./BubbleMarkdown";
import { BulleV2 } from "../../../shared/types/Bubble";

type Props = {
  bubble: BulleV2;
};

const BubbleImage = (props: Props) => {
  const { bubble } = props;

  return (
    <div key={bubble.uid} className="rd-image-bubble">
      {/* Image bubbles have no text, hence no dico */}
      <BubbleMarkdown bubble={bubble} params={{ fontSize: 16, color: "#1e1e1e", isDYS: false }} clickDico={() => {}} />
    </div>
  );
};

export default BubbleImage;
